import styled from 'styled-components'
import { iPadDown } from '../../styles/mediaQueries'
import globalTheme from '../../styles/theme'
import { DolaThemeProps } from '../../styles/types'

export const Wrapper = styled.div<DolaThemeProps>`
  background: ${({ dolaTheme }) => globalTheme[dolaTheme].background};
  max-height: 100vh;
  overflow: auto;
  padding: 3.13vw 2.35vw;

  ${iPadDown} {
    max-height: 75vh;
    padding: 9.66vw 7.25vw;
  }
`

export const IconWrapper = styled.div`
  svg {
    height: 3.91vw;
    width: auto;

    ${iPadDown} {
      height: 12.08vw;
    }
  }
`

export const StyledNotificationText = styled.div`
  p {
    font-size: 1.41vw;
    font-weight: bold;

    ${iPadDown} {
      font-size: 5vw;
    }
  }
`

interface DoubleButtonWrapperProps {
  stackOnMobile?: boolean
}

export const DoubleButtonWrapper = styled.div<DoubleButtonWrapperProps>`
  display: flex;

  ${({ stackOnMobile }) =>
    stackOnMobile
      ? `
    ${iPadDown} {
    flex-direction: column;

    > a {
      display: flex;
    }
  }
  `
      : ''}

  > :first-child {
    margin-right: 0.78vw;

    ${iPadDown} {
      margin-right: ${({ stackOnMobile }) => (stackOnMobile ? '0' : `2.42vw`)};
      margin-bottom: ${({ stackOnMobile }) => (stackOnMobile ? '2vw' : '0')};
    }
  }
`
